import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import swal from 'sweetalert2';        

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss']
})
export class InicioComponent implements OnInit {

  public loading = false;

  public _municipios: any;

  constructor(
    public router:Router,
    public authService:AuthService
  ) { }

  ngOnInit() {

    var res = JSON.parse(localStorage.getItem('dat'));
    if (res!=null)
    {
      this.municipios("2");
    }
    else
    {
      this.router.navigate(['/login'])
    }

  }


  municipios(id){    
    this.loading =true;    
    this.authService.municipios(id)
      .then(
          data => {
            this.loading = false;            
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this._municipios = data;  
              this.loading =false;            
            }
            else
            {
              swal.fire('¡Información incorrecta!', '', 'error');
            }
          },
          error => {
              this.loading = false;
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡Información incorrecta!', '', 'error');
          });          
  }

}
